import { success, error as notificationError } from 'react-notification-system-redux';
import store from '@src/store';
export const SEND_CUSTSERV_EMAIL_START = 'SEND_CUSTSERV_EMAIL_START';
export const SEND_CUSTSERV_EMAIL_SUCCESS = 'SEND_CUSTSERV_EMAIL_SUCCESS';
export const SEND_CUSTSERV_EMAIL_ERROR = 'SEND_CUSTSERV_EMAIL_ERROR';
export const SEND_CUSTSERV_EMAIL_LOADING = 'SEND_CUSTSERV_EMAIL_LOADING';
export const SEND_CUSTSERV_EMAIL_CANCEL = 'SEND_CUSTSERV_EMAIL_CANCEL';
export const SEND_EXCEPTION_EMAIL_START = 'SEND_EXCEPTION_EMAIL_START';
export const SEND_EXCEPTION_EMAIL_SUCCESS = 'SEND_EXCEPTION_EMAIL_SUCCESS';
export const SEND_EXCEPTION_EMAIL_ERROR = 'SEND_EXCEPTION_EMAIL_ERROR';
export const SEND_EXCEPTION_EMAIL_LOADING = 'SEND_EXCEPTION_EMAIL_LOADING';
export const SEND_EXCEPTION_EMAIL_CANCEL = 'SEND_EXCEPTION_EMAIL_CANCEL';

export type Actions = {
  SEND_CUSTSERV_EMAIL_START: {
    type: typeof SEND_CUSTSERV_EMAIL_START;
    payload: any;
  };
  SEND_CUSTSERV_EMAIL_LOADING: {
    type: typeof SEND_CUSTSERV_EMAIL_LOADING;
    payload: boolean;
  };
  SEND_CUSTSERV_EMAIL_SUCCESS: {
    type: typeof SEND_CUSTSERV_EMAIL_SUCCESS;
    payload: any;
  };
  SEND_CUSTSERV_EMAIL_ERROR: { type: typeof SEND_CUSTSERV_EMAIL_ERROR; payload: any };
  SEND_CUSTSERV_EMAIL_CANCEL: { type: typeof SEND_CUSTSERV_EMAIL_CANCEL; payload: any };
  SEND_EXCEPTION_EMAIL_START: {
    type: typeof SEND_EXCEPTION_EMAIL_START;
    payload: any;
  };
  SEND_EXCEPTION_EMAIL_LOADING: {
    type: typeof SEND_EXCEPTION_EMAIL_LOADING;
    payload: boolean;
  };
  SEND_EXCEPTION_EMAIL_SUCCESS: {
    type: typeof SEND_EXCEPTION_EMAIL_SUCCESS;
    payload: any;
  };
  SEND_EXCEPTION_EMAIL_ERROR: { type: typeof SEND_EXCEPTION_EMAIL_ERROR; payload: any };
  SEND_EXCEPTION_EMAIL_CANCEL: { type: typeof SEND_EXCEPTION_EMAIL_CANCEL; payload: any };
};
// Action Creators
export const actionCreators = {
  sendCustservEmailStart: (
    payload: any,
  ): Actions[typeof SEND_CUSTSERV_EMAIL_START] => ({
    type: SEND_CUSTSERV_EMAIL_START,
    payload,
  }),
  sendCustservEmailError: (
    payload: any,
  ): Actions[typeof SEND_CUSTSERV_EMAIL_ERROR] => {
     return ({ type: SEND_CUSTSERV_EMAIL_ERROR, payload: payload});
   },
  sendCustservEmailSuccess: (
    payload: any,
  ): Actions[typeof SEND_CUSTSERV_EMAIL_SUCCESS] => ({
    type: SEND_CUSTSERV_EMAIL_SUCCESS,
    payload,
  }),
  sendCustservEmailLoading: (
    payload: boolean,
  ): Actions[typeof SEND_CUSTSERV_EMAIL_LOADING] => ({
    type: SEND_CUSTSERV_EMAIL_LOADING,
    payload,
  }),
  sendCustservEmailCancel: (payload: boolean): Actions[typeof SEND_CUSTSERV_EMAIL_CANCEL] => ({
    type: SEND_CUSTSERV_EMAIL_CANCEL,
    payload,
  }),
  sendExceptionEmailStart: (
    payload: any,
  ): Actions[typeof SEND_EXCEPTION_EMAIL_START] => ({
    type: SEND_EXCEPTION_EMAIL_START,
    payload,
  }),
  sendExceptionEmailError: (
    payload: any,
  ): Actions[typeof SEND_EXCEPTION_EMAIL_ERROR] => {
     return ({ type: SEND_EXCEPTION_EMAIL_ERROR, payload: payload});
   },
  sendExceptionEmailSuccess: (
    payload: any,
  ): Actions[typeof SEND_EXCEPTION_EMAIL_SUCCESS] => ({
    type: SEND_EXCEPTION_EMAIL_SUCCESS,
    payload,
  }),
  sendExceptionEmailLoading: (
    payload: boolean,
  ): Actions[typeof SEND_EXCEPTION_EMAIL_LOADING] => ({
    type: SEND_EXCEPTION_EMAIL_LOADING,
    payload,
  }),
  sendExceptionEmailCancel: (payload: boolean): Actions[typeof SEND_EXCEPTION_EMAIL_CANCEL] => ({
    type: SEND_EXCEPTION_EMAIL_CANCEL,
    payload,
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/customer-service/actions.ts